export default __webpack_public_path__ + "static/media/7.0b1db763.png";